var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "medias-container" } },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _vm.mails && _vm.mails.length > 0
          ? _c(
              "div",
              { staticClass: "media-content" },
              [
                _c("div", { staticClass: "media-header" }, [
                  _c("h2", [_vm._v("Mail Ekleri")]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.mails, function (item) {
                  return _c(
                    "div",
                    { key: item._id, staticClass: "mail-item" },
                    [
                      _c("div", { staticClass: "mail-info" }, [
                        _c("div", { staticClass: "mail-sender" }, [
                          _c("span", { staticClass: "sender-avatar" }, [
                            _vm._v(_vm._s(_vm.getSenderInitials(item.sender))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "sender-details" }, [
                            _c("div", { staticClass: "sender-name" }, [
                              _vm._v(_vm._s(item.sender)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mail-time" }, [
                              _vm._v(_vm._s(_vm.getTime(item.created_at))),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "attachments-gallery" },
                        _vm._l(item.attachments, function (attachment) {
                          return _c(
                            "div",
                            {
                              key: attachment._id,
                              staticClass: "attachment-item",
                            },
                            [
                              _vm.isImageFile(attachment.ext)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "attachment-card image-card",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openAttachment(attachment)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "attachment-preview" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: attachment.cdnUrl,
                                              alt: attachment.name || "Unnamed",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "file-type-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  attachment.ext.toUpperCase()
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "attachment-details" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "attachment-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  attachment.name || "Unnamed"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "attachment-meta" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "attachment-size",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatFileSize(
                                                        attachment.size
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm.isPdfFile(attachment.ext)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "attachment-card pdf-card",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openAttachment(attachment)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "attachment-preview pdf-preview",
                                        },
                                        [
                                          _c("embed", {
                                            attrs: {
                                              src: attachment.cdnUrl,
                                              type: "application/pdf",
                                              width: "100%",
                                              height: "100%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "file-type-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  attachment.ext.toUpperCase()
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "attachment-details" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "attachment-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  attachment.name || "Unnamed"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "attachment-meta" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "attachment-size",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatFileSize(
                                                        attachment.size
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm.isVideoFile(attachment.ext)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "attachment-card video-card",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "attachment-preview video-preview",
                                        },
                                        [
                                          _c(
                                            "video",
                                            {
                                              attrs: {
                                                controls: "",
                                                width: "100%",
                                                height: "100%",
                                              },
                                            },
                                            [
                                              _c("source", {
                                                attrs: {
                                                  src: attachment.cdnUrl,
                                                  type: _vm.getVideoMimeType(
                                                    attachment.ext
                                                  ),
                                                },
                                              }),
                                              _vm._v(
                                                "\n                                    Tarayıcınız video etiketini desteklemiyor.\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "file-type-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  attachment.ext.toUpperCase()
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "attachment-details" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "attachment-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  attachment.name || "Unnamed"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "attachment-meta" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "attachment-size",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatFileSize(
                                                        attachment.size
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm.isAudioFile(attachment.ext)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "attachment-card audio-card",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "attachment-preview audio-preview",
                                        },
                                        [
                                          _c(
                                            "audio",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { controls: "" },
                                            },
                                            [
                                              _c("source", {
                                                attrs: {
                                                  src: attachment.cdnUrl,
                                                  type: _vm.getAudioMimeType(
                                                    attachment.ext
                                                  ),
                                                },
                                              }),
                                              _vm._v(
                                                "\n                                    Tarayıcınız ses etiketini desteklemiyor.\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "audio-icon" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    "font-size": "48px",
                                                    color: "#1890ff",
                                                  },
                                                },
                                                [_vm._v("music_note")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "file-type-badge",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      attachment.ext.toUpperCase()
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "attachment-details" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "attachment-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  attachment.name || "Unnamed"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "attachment-meta" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "attachment-size",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatFileSize(
                                                        attachment.size
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm.isTextFile(attachment.ext)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "attachment-card text-card",
                                      on: {
                                        click: function ($event) {
                                          return _vm.previewTextFile(attachment)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "attachment-preview text-preview",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-icon" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    "font-size": "48px",
                                                    color: "#52c41a",
                                                  },
                                                },
                                                [_vm._v("description")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "file-type-badge",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      attachment.ext.toUpperCase()
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "attachment-details" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "attachment-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  attachment.name || "Unnamed"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "attachment-meta" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "attachment-size",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatFileSize(
                                                        attachment.size
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "attachment-card file-card",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openAttachment(attachment)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "attachment-preview file-preview",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "file-icon" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    "font-size": "48px",
                                                    color: "#999",
                                                  },
                                                },
                                                [_vm._v("visibility_off")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "file-type-badge",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      attachment.ext.toUpperCase()
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "attachment-details" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "attachment-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  attachment.name || "Unnamed"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "attachment-meta" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "attachment-size",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatFileSize(
                                                        attachment.size
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "load-more-container" },
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "load-more-button",
                        attrs: { loading: _vm.loadingMore, type: "primary" },
                        on: { click: _vm.loadMore },
                      },
                      [
                        _vm._v(
                          "\n                    Daha Fazla Yükle\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              2
            )
          : _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c("a-empty", {
                  attrs: { description: "Herhangi bir dosya eki bulunamadı" },
                }),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.currentTextFile
              ? _vm.currentTextFile.filename
              : "Dosya Önizleme",
            width: "700px",
            footer: null,
          },
          model: {
            value: _vm.textPreviewVisible,
            callback: function ($$v) {
              _vm.textPreviewVisible = $$v
            },
            expression: "textPreviewVisible",
          },
        },
        [
          _vm.textPreviewContent
            ? _c("pre", { staticClass: "text-preview-content" }, [
                _vm._v(_vm._s(_vm.textPreviewContent)),
              ])
            : _c(
                "div",
                { staticClass: "text-preview-loading" },
                [
                  _c("a-spin"),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _vm._v("Dosya yükleniyor..."),
                  ]),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }